export const REDACTION_RULES: { pattern: RegExp; replacement: string }[] = [
	{
		pattern: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g,
		replacement: '<redacted-email>'
	},
	{ pattern: /\b(bearer|basic)\s+[A-Za-z0-9._~+/=-]+/gi, replacement: '$1 <redacted>' },
	{ pattern: /\b(authorization)\b(["':=\s]+)[^\s",}]+/gi, replacement: '$1$2<redacted>' },
	{
		pattern: /\b(token|password|passwd|secret|api[_-]?key)\b(["':=\s]+)[^\s",}]+/gi,
		replacement: '$1$2<redacted>'
	}
];

export const SENSITIVE_CONTEXT_KEY_PATTERN = /^(token|password|passwd|secret|api[_-]?key)$/i;
